module.exports = __webpack_public_path__ + "47a9178fac066a60f3424df66f958ca9.jpg";